import React from "react";
import {
  View,
  Image,
  SafeAreaView,
  Text,
  Pressable,
  FlatList,
  Modal,
  TouchableOpacity,
} from "react-native";
import { ids, styles } from "./Style";
import { ScreenNameList } from "@lib/utilities/Constants";
import { CROSS_ICON } from "../../resources/IMAGES";
import ActivityIndicatorLoader from "../common/ActivityIndicatorLoader";
import NotificationListItem from "./NotificationListItem";
import CustomAlert from "../common/CustomAlert";
import commonStyle from "../../assets/styles/common-style";
import { messages } from "../../resources/strings";
import { useNotification } from "@lib/hooks/notification/useNotification";
import MainContainer from "../common/MainContainer";

const NotificationCenter = (props: any) => {
  const {
    onNotificationItemClick,
    onReloadPress,
    handleInvalidTokenCase,
    isLoading,
    notificationList,
    errorHandle,
    setErrorHandle,
    errorData,
  } = useNotification(props);
  return (
    <Modal
      visible={props.isNotificationCenterVisible}
      animationType="none"
      transparent={true}
    >
      <MainContainer
        screenName={ScreenNameList.notificationCenter}
        navigation={undefined}
        errorData={errorData}
      >
        <SafeAreaView style={[styles.containerFluid]}>
          <View style={styles.rightPanel} dataSet={{ media: ids.rightPanel }}>
            <View
              style={[styles.closePanel]}
              dataSet={{ media: ids.closePanel }}
            >
              <View
                style={[styles.profileSection]}
                dataSet={{ media: ids.profileSection }}
              >
                <Text style={styles.heading} dataSet={{ media: ids.heading }}>
                  Notifications
                </Text>
                <Pressable
                  onPress={() => {
                    props.closeNotificationCenter();
                  }}
                  style={styles.crossIconTouch}
                  dataSet={{ media: ids.crossIconTouch }}
                >
                  <Image
                    style={styles.crossIcon}
                    dataSet={{ media: ids.crossIcon }}
                    source={CROSS_ICON}
                  />
                </Pressable>
              </View>
            </View>
            <View
              style={[styles.notificationContainer]}
              dataSet={{ media: ids.notificationContainer }}
            >
              {isLoading && (
                <View
                  style={{
                    justifyContent: "center",
                    flex: 1,
                    alignItems: "center",
                  }}
                >
                  <ActivityIndicatorLoader
                    data={{
                      screenName: ScreenNameList.notificationCenter,
                      color: "#000",
                    }}
                    indicator={true}
                  />
                </View>
              )}
              {!isLoading && notificationList && (
                <FlatList
                  showsVerticalScrollIndicator={false}
                  showsHorizontalScrollIndicator={false}
                  keyExtractor={(index) => "key" + index}
                  data={notificationList}
                  renderItem={({ item }) => {
                    return (
                      <NotificationListItem
                        notificationItem={item}
                        onItemPress={() => {
                          onNotificationItemClick(item);
                        }}
                      />
                    );
                  }}
                />
              )}
            </View>
            {errorHandle != messages.error.noError && !isLoading && (
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  flex: 1,
                }}
              >
                <View style={[commonStyle.styles.errorView]}>
                  <CustomAlert
                    data={{
                      message: errorHandle,
                      screenName: ScreenNameList.notificationCenter,
                      color:
                        errorHandle == messages.error.noNotificationFound
                          ? "#000"
                          : null,
                    }}
                    onReloadPress={onReloadPress}
                    onEndTimer={() => {
                      setErrorHandle(messages.error.noError);
                    }}
                    onEndLogoutTimer={() => {
                      handleInvalidTokenCase();
                    }}
                  />
                </View>
              </View>
            )}
          </View>
          <TouchableOpacity
            onPress={() => {
              props.closeNotificationCenter();
            }}
            style={styles.overlay}
          >
            <View
              style={styles.overlay}
              dataSet={{ media: ids.overlay }}
            ></View>
          </TouchableOpacity>
        </SafeAreaView>
      </MainContainer>
    </Modal>
  );
};

export default NotificationCenter;
